import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { z } from "zod";

import { apiRequest } from "./apiUtils";

export const communicationPreferencesSchema = z.object({
  sms_updates: z.boolean(),
  email_updates: z.boolean(),
});
export type CommunicationPreferences = z.infer<
  typeof communicationPreferencesSchema
>;

export const communicationPrefsKeys = {
  me: ["communication-preferences", "me"] as const,
};

export async function getCommunicationPreferences(): Promise<CommunicationPreferences> {
  const res = await apiRequest<unknown>("user/communication-preferences", {
    method: "GET",
  });
  return communicationPreferencesSchema.parse(res);
}

export async function updateCommunicationPreferences(
  body: CommunicationPreferences,
): Promise<CommunicationPreferences> {
  const res = await apiRequest<unknown>("user/communication-preferences", {
    method: "PUT",
    body: JSON.stringify(body),
  });
  return communicationPreferencesSchema.parse(res);
}

export function useCommunicationPreferences() {
  return useQuery<CommunicationPreferences>({
    queryKey: communicationPrefsKeys.me,
    queryFn: getCommunicationPreferences,
  });
}

export function useUpdateCommunicationPreferences() {
  const qc = useQueryClient();
  return useMutation<
    CommunicationPreferences,
    Error,
    CommunicationPreferences
  >({
    mutationFn: updateCommunicationPreferences,
    onSuccess: (data) => qc.setQueryData(communicationPrefsKeys.me, data),
  });
}
